var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"progress",staticClass:"progress",class:{'is-dark': _vm.dark}},[_c('div',{staticClass:"progress-value"},[_vm._v(_vm._s(_vm._f("round")(_vm.percent))),_c('small',[_vm._v("%")])])])}
var staticRenderFns = []

export { render, staticRenderFns }